export default __webpack_public_path__ + "static/media/bullet-manhattan-1-flipped.840500c9.svg";